module.exports = __webpack_public_path__ + "img/fwlcImg4.a7a1f047.png";